



































import Component, { mixins } from "vue-class-component";
import RecurrenceUtils from "../utils/recurrenceUtils";
import { RecurrenceRule, Destinataire, Abonnement } from "@/shared/Recurrence";
import RapportSelection from "@/components/rapportSelection.vue";
import ErrorMixin from "@/mixins/errorMixins";
import RegleRecurrence from "./recurrences/recurrencesRegle.vue";
import DestinationRecurrence from "./recurrences/recurrencesDestinations.vue";
import AbonnementsRecurrences from "./recurrences/recurrencesAbonnements.vue";
import RuleAdder from "./recurrences/ruleAdder.vue";
import DestinationAdder from "./recurrences/destinationAdder.vue";
@Component({
  components: {
    RapportSelection,
    RegleRecurrence,
    DestinationRecurrence,
    AbonnementsRecurrences,
    RuleAdder,
    DestinationAdder,
  },
})
export default class Recurrence extends mixins(ErrorMixin) {
  /**
   * variables permettants de choisir quel onglet activer pour les v-tabs
   */
  public tab = 0;

  /**
   * variables permettants de stocker les différentes règles, destinaires et abonnements déjà existants
   */
  public listRules = new Array();
  public listDests = new Array();
  public listAbos = new Array();

  /**
   * variable pour utiliser différentes vue pour définir les regles (un pour fec et un pour recurrence normale)
   */
  public RuleAdderComponent = RuleAdder;
  public DestinationAdderComponent = DestinationAdder;

  /**
   * variable permettant de relier les différents règles avec les destinataires en fonction des abonnements
   */
  public rulesOfDest: any = {};

  public mounted() {
    RecurrenceUtils.getAllRules().then((rules: any) => {
      this.listRules = rules.filter(
        (rule: any) => rule.fabricExportableClassName !== "FabricExportableFec"
      );
    });

    RecurrenceUtils.getAllAbos().then((abos: any) => {
      this.listAbos = abos.filter(
        (abo: any) =>
          abo.regleExportable.fabricExportableClassName !==
          "FabricExportableFec"
      );
    });

    this.loadDestinataires();
  }

  /**
   * Méthode permettant de supprimer une règle
   * @param rule La règle à supprimer
   */
  public deleteRule(rule: RecurrenceRule) {
    this.listRules = this.listRules.filter(
      (re: RecurrenceRule) => re.id !== rule.id
    );
  }

  /**
   * Méthode visant d'ajouter
   * @param abo
   */
  public async addDest(abo: Destinataire) {
    this.listDests.push(abo);
  }

  /*
   * Méthode permettant de supprimer une règle
   */
  public deleteDest(rule: Destinataire) {
    this.listDests = this.listDests.filter(
      (re: Destinataire) => re.id !== rule.id
    );
  }

  /**
   *
   * @param abo
   */
  public async addRule(abo: RecurrenceRule) {
    this.listRules.push(abo);
  }

  /*
   * Méthode permettant d'ajouter un nouvel abonnement
   */
  public async addAbo(abo: Abonnement) {
    this.listAbos.push(abo);
  }

  /*
   * Méthode permettant de supprimer un abonnement
   */
  public async deleteAbo(abonnement: Abonnement) {
    const ruleId = abonnement.regleExportable.id;
    const dest = abonnement.regleDestinations;

    dest.forEach((destination: any) => {
      RecurrenceUtils.unsubscribeAbo(ruleId, destination.id).then(
        (response: any) => {
          RecurrenceUtils.getAllAbos().then((abos: any) => {
            this.listAbos = abos;
          });

          this.listDests.forEach((destinataire: any) => {
            RecurrenceUtils.getRulesOfDest(destinataire).then(
              (mesabos: any) => {
                if (mesabos.length > 0) {
                  destinataire.$abonnements = mesabos;
                }
              }
            );
          });
        }
      );

      RecurrenceUtils.deleteAbo(abonnement.id).then((response: any) => {
        this.setSuccess(this.$t("supprAbo").toString());
      });
    });
  }

  public unsubscribe(evt: any) {
    console.log(evt);

    RecurrenceUtils.unsubscribeAbo(evt.ruleid, evt.dest.id).then(
      (response: any) => {
        this.loadDestinataires();

        RecurrenceUtils.getAllAbos().then((abos: any) => {
          this.listAbos = abos;
        });

        this.setSuccess(this.$t("supprAbo").toString());
      }
    );
  }

  private loadDestinataires() {
    RecurrenceUtils.getAllDests().then((dest: any) => {
      this.listDests = dest;

      this.listDests.forEach((destinataire: any) => {
        RecurrenceUtils.getRulesOfDest(destinataire).then((mesabos: any) => {
          if (mesabos.length > 0) {
            destinataire.$abonnements = mesabos.filter(
              (rule: any) =>
                rule.fabricExportableClassName !== "FabricExportableFec"
            );
          }
        });
      });
    });
  }

  get me(): any {
    return this.$store.getters["login/user"];
  }
}
